import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ControlLabel,
  Form,
  FormGroup,
} from 'react-bootstrap';
import { Form as FinalForm, FORM_ERROR } from 'react-final-form';
import { Field } from 'react-final-form-html5-validation';
import arrayMutators from 'final-form-arrays';
import { FinalFormClioDocumentCategorySelector } from "./ClioDocumentCategorySelector";
import request from 'superagent';
import { notify } from 'common/Notification';

export default class ClioConnectionSettingsForm extends Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    clioSettings: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  render() {
    const {connectionId, clioSettings, onSave} = this.props;

    return (
      <FinalForm onSubmit={onSave} initialValues={clioSettings} mutators={{...arrayMutators}}>
        {({handleSubmit, pristine, submitting }) =>
          <Form horizontal style={{padding: "8px 42px 8px 16px",}} onSubmit={handleSubmit}>
            <FormGroup>
              <ControlLabel>Default Document Category</ControlLabel>
              <Field name="document_category_id" connectionId={connectionId} component={FinalFormClioDocumentCategorySelector} />
            </FormGroup>

            <FormGroup>
              <Button type="submit" bsStyle="primary" disabled={pristine || submitting}>Save</Button>
            </FormGroup>
          </Form>
        }
      </FinalForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/ClioConnectionSettingsForm.jsx